// Campo de contraseña reutilizable — mostrar/ocultar (ver informe "LYNX —
// Fase 1.1: Usuarios y Seguridad"). Extraído del patrón que ya existía
// duplicado 2 veces dentro de Login.tsx (mobile/desktop) — ahora un único
// componente, reusado también en Crear/Editar Usuario. Envuelve el <Input>
// existente (hereda estilo, `error`, `helperText`, y reenvía cualquier
// prop nativa como `autoComplete`).
import React, { useState } from "react";
import Input, { InputProps } from "./Input";

type PasswordInputProps = Omit<InputProps, "type"> & {
  toggleAriaLabel?: string;
};

const toggleButtonStyle: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  right: "14px",
  transform: "translateY(-50%)",
  border: "none",
  background: "transparent",
  color: "var(--text-secondary)",
  cursor: "pointer",
  padding: "4px",
  fontSize: "18px",
  lineHeight: 1,
  zIndex: 2,
};

export default function PasswordInput({ style, ...props }: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      <Input
        {...props}
        type={visible ? "text" : "password"}
        style={{ paddingRight: "44px", ...style }}
      />
      <button
        type="button"
        onClick={() => setVisible((prev) => !prev)}
        aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
        title={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
        style={toggleButtonStyle}
      >
        {visible ? "🙈" : "👁️"}
      </button>
    </div>
  );
}
